module.exports = __webpack_public_path__ + "img/checkout-desktop.167a67d6.svg";